<template>
    <div class="settings-form">

        <!-- Título da página -->
        <mu-title color="secondary" textStrong="700">Empresa</mu-title>

        <!-- Breadcrumbs -->
        <mu-breadcrumbs divider="—">
            <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
            <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
        </mu-breadcrumbs>

        <mu-form-company type="edit"></mu-form-company>

    </div>
</template>

<script>
    export default {
        name: 'app-settings-form',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Configurações',
                        route: 'app.settings',
                        disabled: false
                    },
                    {
                        text: 'Empresa',
                        disabled: true
                    }
                ]
            }
        }
    }
</script>
